<template>
  <div class="domino-player">
    <div class="domino-player-title">{{ $t("general.Sum_Player") }}</div>
    <div class="domino-player-container">
      <new-bet-lot
        v-for="item in gameRow1"
        class="domino-player-betlot"
        :key="item"
        :type="item"
        :win="winNumbers[0] === item"
        :odd="odd(item)"
        :gameType="game"
        :game="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
    <div class="domino-player-divider"></div>
    <div class="domino-player-container">
      <new-bet-lot
        v-for="item in gameRow2"
        class="domino-player-betlot"
        :key="item"
        :type="item"
        :win="winNumbers[1] === item"
        :odd="odd(item)"
        :gameType="game"
        :game="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["game", "winNumbers", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      gameRow1: ["o4", "o5"],
      gameRow2: ["o6", "o7"]
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.domino-player {
  width: 50%;
}
.domino-player-title {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #1c3a67;
  font-weight: bold;
  color: white;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  border-right: 1px solid #254a83;
}
.domino-player-container {
  display: flex;
  padding: 5px 5px 0;
}
.domino-player-divider {
  height: 1px;
}
.domino-player-betlot {
  flex: auto;
  width: 50%;
  background: #ffffff;
}

.domino-player-betlot:hover {
  background: #f5eeb8;
  cursor: pointer;
}

.domino-player-betlot:first-of-type {
  margin-left: unset;
  border-radius: 5px 0 0 5px;
}

.domino-player-betlot:last-of-type {
  margin-right: unset;
  border-radius: 0 5px 5px 0;
}
</style>
